import Content from '../../content';

namespace('IO.Views.IccPolicies', function (exports) {
  'use strict';

  var IpField = IO.Views.Components.IpField,
    InternetAddress = IO.Views.Components.InternetAddress,
    New = Content.extend({
      dom: {
        IO_FORM: '.io-form',
        SAVE_BUTTON: '.io-form-action-save',
        CATEGORIES_OPTIONS: '.icc-category',
        CATEGORIES_FILTER_SEARCH_INPUT: '#icc-search-input',
        SELECT2_FIELD: 'select.select2select.node-groups',
        DEFAULT_ICC_CONFIG: '#icc-policy-default',
        IP_ADDRESS: '#icc-ip',
        NODE_GROUPS: '#node_groups',
        REDIRECT_FIELD: '#icc-redirect',
        NETWORK_OPTIONS: '.icc-network-options',
        TRAFFIC_CONTROL: '#icc_policy_other_traffic_action',
        WHITE_LIST: '#icc_policy_whitelist',
        BLACK_LIST: '#icc_policy_blacklist',
        DELETE_BUTTON: '#icc-delete',
      },

      render: function () {
        var $select;

        this.categories =
          this.categories || this.$el.find(this.dom.CATEGORIES_OPTIONS);
        this.categoriesSearchInput =
          this.categoriesSearchInput ||
          this.$el.find(this.dom.CATEGORIES_FILTER_SEARCH_INPUT);

        this.categoriesSearchInput
          .off('keyup')
          .on('keyup', this._filterCategories.bind(this));

        this._showTrafficControlAlert();
        $(this.dom.DELETE_BUTTON).on('click', this._warnIccImpact);
        $(this.dom.TRAFFIC_CONTROL).on('change', this._showTrafficControlAlert);
        $(this.dom.WHITE_LIST).on('keyup', this._showTrafficControlAlert);
        $(this.dom.BLACK_LIST).on('keyup', this._showTrafficControlAlert);

        $(this.dom.SAVE_BUTTON).on(
          'click',
          this._checkNodeGroupsIccPoliciesBeforeSave.bind(this),
        );

        $select = this.$el.find(this.dom.SELECT2_FIELD);

        if (!$select.closest('.hide').length) {
          $select.select2({
            placeholder: 'Select Node Groups to apply to',
          });
        }

        this._checkDefaultPolicyConfiguration();
        this._checkDefaultPolicyUniqueness();

        new IpField({ el: this.$el.find(this.dom.IP_ADDRESS) });
        new InternetAddress({ el: this.$el.find(this.dom.REDIRECT_FIELD) });
      },

      _warnIccImpact: function (e) {
        var id = $(e.target).attr('rel'),
          warnModal;

        if (!$(e.target).hasClass('triggered')) {
          e.preventDefault();

          warnModal = new IO.Views.Components.ConfirmationDialog({
            url: '/' + currentCustomer + '/icc_policies/' + id + '/impacted',
            jst_template: 'icc_policies/impacted_icc', // eslint-disable-line camelcase
            method: 'GET',
          });
          warnModal.impact();
          warnModal.answer(function (proceed) {
            if (proceed) {
              $(e.target).addClass('triggered').trigger('click');
            }
            warnModal.destroy();
          });
          return false;
        }
      },

      _showTrafficControlAlert: function () {
        var element = $('#icc_policy_other_traffic_action'),
          shouldWarn = false,
          alertMsg;

        element.parent().find('small').remove();

        if (
          element.val() === 'deny' &&
          $('#icc_policy_whitelist').val() === ''
        ) {
          shouldWarn = true;
          alertMsg = 'This ICC configuration DENY all traffic for this network';
        } else if (
          element.val() === 'allow' &&
          $('#icc_policy_blacklist').val() === ''
        ) {
          shouldWarn = true;
          alertMsg =
            'This ICC configuration ALLOW all traffic for this network';
        }

        if (shouldWarn) {
          element
            .parent()
            .append("<small class='warning'>" + alertMsg + '</small>');
        }
      },

      _filterCategories: function () {
        if (this.categoriesSearchInput.val() === '') {
          this.categories.removeClass('hide');
        } else {
          this.categories
            .filter(':not(:contains(' + this.categoriesSearchInput.val() + '))')
            .addClass('hide');

          this.categories
            .filter(':contains(' + this.categoriesSearchInput.val() + ')')
            .removeClass('hide');
        }
      },

      _checkDefaultPolicyConfiguration: function () {
        var self = this;

        $(this.dom.DEFAULT_ICC_CONFIG).change(function () {
          var networkOptions = $(self.dom.NETWORK_OPTIONS);

          if (this.checked === true) {
            networkOptions.addClass('hidden');
          } else {
            networkOptions.removeClass('hidden');
          }
        });
      },

      _checkDefaultPolicyUniqueness: function () {
        var saveBtn = this.dom.SAVE_BUTTON;

        $(this.dom.DEFAULT_ICC_CONFIG).change(function (event) {
          if (
            event.target.checked === true &&
            typeof policyId !== 'undefined'
          ) {
            $.ajax({
              url: '/' + currentCustomer + '/icc_policies/check_default',
              type: 'post',
              headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
              },
              data: { policy_id: policyId },
              success: function (data) {
                if (data.empty === false) {
                  $(saveBtn).attr('disabled', true);
                  new IO.Views.IccPolicies.ImpactedIccResourcesModal({
                    wait: true,
                  }).open(data);
                } else {
                  $(saveBtn).attr('disabled', false);
                }
              },
            });
          } else {
            $(saveBtn).attr('disabled', false);
          }
        });
      },

      _getNodeGroupNames: function (nodeGroupIds) {
        var self = this,
          nodeGroupNames,
          _getNodeGroupName;

        _getNodeGroupName = function (nodeGroupId) {
          return $(
            self.dom.NODE_GROUPS + ' option[value="' + nodeGroupId + '"]',
          ).text();
        };

        nodeGroupNames = [];
        $.each(nodeGroupIds, function (_, nodeGroupId) {
          nodeGroupNames.push(_getNodeGroupName(nodeGroupId));
        });
        return nodeGroupNames;
      },

      _checkNodeGroupsIccPoliciesBeforeSave: function (e) {
        var self = this,
          nodeGroupIds,
          policyId,
          _doIt;

        if (!$(this.dom.DEFAULT_ICC_CONFIG).next().hasClass('checked')) {
          return;
        }

        nodeGroupIds = $(this.dom.NODE_GROUPS).val();
        if ($.isEmptyObject(nodeGroupIds)) {
          return;
        }

        e.preventDefault();

        _doIt = function () {
          $(self.dom.IO_FORM).submit();
        };

        policyId = window.location.href.match(/\d*$/)[0];

        $.ajax({
          url:
            '/' +
            currentCustomer +
            '/icc_policies/node_groups_default_icc_policies',
          data: { node_group_ids: nodeGroupIds, policy_id: policyId }, // eslint-disable-line camelcase
        }).done(function (data) {
          if (data.node_group_ids.length === 0) {
            // eslint-disable-line camelcase
            _doIt();
          } else {
            self._showModal(
              self._getNodeGroupNames(data.node_group_ids), // eslint-disable-line camelcase
              function (proceed) {
                if (proceed === true) {
                  _doIt();
                }
              },
            );
          }
        });
      },

      _showModal: function (nodeGroups, confirmationCallback) {
        var number, msg, _humanizedJoin;

        if (!this.confirmationModal) {
          this.confirmationModal = new IO.Views.ConfirmationModal({
            el: '#confirmation-modal',
            closeable: false,
          });
        }

        _humanizedJoin = function (strList) {
          var result = '';

          if (strList.length === 1) {
            result = strList[0];
          } else if (strList.length === 2) {
            result = strList[0] + '"</b> and <b>"' + strList[1];
          } else if (strList.length > 2) {
            result = [
              strList.slice(0, -1).join('"</b>, <b>"'),
              strList.slice(-1)[0],
            ].join('"</b>, and <b>"');
          }

          return '<b>"' + result + '"</b>';
        };

        if (nodeGroups.length > 1) {
          number = ['node groups', 'have', 'these node groups'];
        } else {
          number = ['node group', 'has', 'this node group'];
        }

        msg =
          'The ' +
          number[0] +
          ' ' +
          _humanizedJoin(nodeGroups) +
          ' already ' +
          number[1] +
          ' a default ICC Policy.<br>Do you want to save and make the present ICC Policy' +
          ' the new default for ' +
          number[2] +
          '?';
        this.confirmationModal.show(msg, confirmationCallback);
        $('.modal-background').css({ zIndex: 100 });
      },
    });

  exports.New = New;
});
